module.exports = __webpack_public_path__ + "assets/img/icon5.fd75c061.png";